module.exports = __webpack_public_path__ + "static/media/logo-CDC.07a2f878.png";